import React from 'react'
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import { BaseUrl } from '../../helper/BaseUrl';

export default function OtherProjects({ extraClass = "", allData }) {

    const settingskey = {
        autoplay: true,
        speed: 3000,
        infinite: true,
        arrows: true,
        dots: false,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: (
            <button className="slick-arrow slick-prev" aria-label="Previous Slide">
                <i className="fa-solid fa-arrow-left"></i>
            </button>
        ),

        nextArrow: (
            <button className="slick-arrow slick-next" aria-label="Next Slide">
                <i className="fa-solid fa-arrow-right"></i>
            </button>
        ),
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                },
            },

            {
                breakpoint: 99999,
                settings: "unslick",
            },
        ],
    };
    return (
        <>
            <section className={`project-card-listing ${extraClass}`}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-12 col-lg-10">
                            <div className="project-text">
                                <h2 className="heading">Other projects</h2>
                            </div>
                        </div>
                    </div>
                    <div className="project-row">
                        <Slider {...settingskey} className="other-detail-slides">
                            {allData?.slice(-3)?.map((item, index) => (
                                <div className="other-detail-card" key={index}>
                                    <div className="project-card">
                                        <Link className="project-card-inner" to={`/project/${item.slug}`}>
                                            <div className="image-wrapper">
                                                <img src={item?.thumbnail ? `${BaseUrl}${item.thumbnail}` : undefined} className="img-responsive" alt={item?.alt_thumbnail} loading="lazy" />
                                            </div>
                                            <div className="project-detail">
                                                <span className="gradient-color">{item?.country} </span>
                                                <h3 className="heading">{item?.title}</h3>
                                                <div className="arrow-butn">View Projects<img src="/assets/images/arrow.webp" loading="lazy" alt="arrow" />
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                        <div className="row">
                            <div className="col-sm-12 col-lg-12">
                                <div className='text-center'>
                                    <Link to={"/project"} className="default-btn"><span>View More</span></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
